export var JurisdictionsEnum;
(function (JurisdictionsEnum) {
    JurisdictionsEnum["GLOBAL"] = "global";
    JurisdictionsEnum["GE"] = "ge";
    JurisdictionsEnum["UA"] = "ua";
    JurisdictionsEnum["EU"] = "eu";
})(JurisdictionsEnum || (JurisdictionsEnum = {}));
//# sourceMappingURL=jurisdictions.enum.js.map